import React from 'react';
import dateFormater from '../../helpers/dataFormart.js';
import './OrderCard.css';
import { Link } from 'react-router-dom';

function OrderCard(props) {
  const {
    _id,
    _customerName,
    _value,
    _date,
    _status,
  } = props.order

  const colorStatus = {
    "Aguardando pagamento": "#FACF36",
    "pedido cancelado": "#F81005",
    "pagamento confirmado": "#36FA55",
    "pedido entregue": "#0C5420",
    "aguardando resposta do cliente": "#36FAD6",
  }

  return (
    <Link to={`/pedido/${_id}`} className="order-card">
      <div className="order-status" style={{backgroundColor: colorStatus[_status]}}>
        <h4>{_status.toLowerCase()}</h4>
      </div>
      <div className="order-card-details">
        <h3 className='card-title'>{_customerName}</h3>
        <p>id: {_id}</p>
        <p>data: {dateFormater(_date)}</p>
        <p>valor: R$ {_value.toFixed(2).replace('.', ',')}</p>
      </div>
    </Link>
  )
};

export default OrderCard;
